/**
 * Created by haluk on 6/12/17.
 */

const v1 = resolve => require(['./v1.vue'], resolve);

export default {
  v1
}
